export default __webpack_public_path__ + "static/media/ETP_PJG.19a57aae.png";